
<template>
  <div class="TemplateList">
    <div class="page-container">
      <div class="section">
        <!--标题栏-->
        <div class="control-box">
          <div class="cb-left">
            <h1 style="font-size: 20px">{{ $t('inspection_record') }}</h1>
          </div>
        </div>

        <!--搜索栏-->
        <div class="control-box" style="padding-bottom: 0;">
          <div class="cb-left">
            <el-form ref="form" inline class="control-item" :model="form" label-width="auto">
              <el-form-item :label="$t('device_type') + '：'">
                <el-select
                    v-model="form.deviceId"
                    clearable
                    style="width: 150px"
                    @clear="form.deviceId = undefined"
                >
                  <el-option
                      v-for="item in deviceList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                  />
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('maintenance_type') + '：'">
                <el-select
                    v-model="form.type"
                    clearable
                    style="width: 150px"
                    @clear="form.type = undefined"
                >
                  <el-option
                      v-for="item in option.maintainTypes"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                  />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button
                    class="control-item"
                    icon="el-icon-search"
                    type="primary"
                    @click="handleFilter"
                >
                  {{ $t('search') }}
                </el-button>
                <el-button :loading="loading" v-if="roleType === 3 || roleType === 2" type="primary" @click="handleExport()" >
                  {{ $t('BatchExport') }}
                </el-button>
              </el-form-item>
            </el-form>
          </div>
          <!--右-->

        </div>

        <div class="table-box">
          <el-table
              v-loading="listLoading"
              :data="templateList"
              element-loading-text="Loading"
              border
              fit
              highlight-current-row
              @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" v-if="roleType === 3 || roleType === 2" model="" width="50" ></el-table-column>
            <el-table-column :label="$t('deviceName')" align="center">
              <template slot-scope="scope">
                {{ scope.row.deviceName }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('maintenance_type')" align="center">
              <template slot-scope="scope">
                {{scope.row.printType === '0' ? $t('pre_press') : scope.row.printType === '1' ? $t('printing') : scope.row.printType === '2' ? $t('Post_Press') : ''}}{{ scope.row.daType === '1' ? $t('day_maintainance') : scope.row.daType === '2' ? $t('weeks_maintainance') : scope.row.daType === '3' ? $t('months_maintainance') :scope.row.daType === '30' ? $t('half_months_maintainance') :scope.row.daType === '4' ? $t('quarter_maintainance') :scope.row.daType === '5' ? $t('half_year_maintainance') : $t('year_maintainance') }}
              </template>
            </el-table-column>

            <el-table-column :label="$t('maintenance_personnel')" align="center">
              <template slot-scope="scope">
                {{ scope.row.person }}
              </template>
            </el-table-column>

            <el-table-column :label="$t('inspection_time')" align="center">
              <template slot-scope="scope">
                {{ scope.row.date }}
              </template>
            </el-table-column>

            <!--操作-->
            <el-table-column :label="$t('caozuo')" align="center" width="150">
              <template slot-scope="scope">
                <el-button
                    type="primary"
                    size="mini"
                    @click="showTemplateDetail(scope.row)"
                >
                  {{ $t('device_view') }}
                </el-button>
                <el-button type="primary" size="mini" v-if="roleType === 3 || roleType === 2" @click="handleExport(scope.row)" plain >
                  {{ $t('export') }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!--分页-->
        <div class="pagination-box">
          <el-pagination
              :page-sizes="[10, 20, 30, 40]"
              :page-size="form.count"
              :total="totalCount"
              :current-page="form.page"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api';
import { manageOauth } from '@/utils/validate';
import convert from '@/utils/convert';
import valid from '@/utils/validator';

export default {
  name: 'inspectionRecords',
  data() {
    return {
      buttons: '',
      deviceList: [],
      listLoading: false,
      templateList: [],
      // 查询
      form: {
        deviceId: '', // 设备类型
        type: -1, // 保养类型
        page: 1,
        count: 10,
      },
      // 下拉选项
      option: {
        // 保养类型
        maintainTypes: [
          { name: this.$t('all'), id: -1 },
          { name: this.$t('day_maintainance'), id: 1 },
          { name: this.$t('weeks_maintainance'), id: 2 },
          { name: this.$t('months_maintainance'), id: 3 },
          { name: this.$t('quarter_maintainance'), id: 4 },
          { name: this.$t('semi_annual_maintenance'), id: 5 },
          { name: this.$t('annual_maintenance'), id: 6 },
        ],
      },
      totalCount: 0,
      exportData: [],
      loading: false,
    };
  },
  computed: {
    roleType() {
      // this.value1 = localStorage.getItem('deviceId')
      return this.$store.state.userInfo.roleType
    },
  },
  created() {
    this.form.page = this.$store.state.inspectionForm.page
    this.form.count = this.$store.state.inspectionForm.count
    this.form.deviceId = this.$store.state.inspectionForm.deviceId
    this.form.type = this.$store.state.inspectionForm.type
    this.getDeviceList();
    this.getTemplateList();
  },
  methods: {
    // 搜索
    handleFilter() {
      if (!this.form.type) {
        this.form.type = -1
      }
      this.form.page = 1
      this.getTemplateList()
    },
    getDeviceList() {
      API.deviceList()
          .then((response) => {
            this.deviceList = response.message.data
            this.deviceList.unshift({name: this.$t('alldevice'),id: ''})
          })
    },
    // 获取模板列表
    getTemplateList() {
      API.checkList(this.form).then((response) => {
        this.templateList = response.message.data.list;
        this.totalCount = response.message.data.totalCount;
      });
    },
    showTemplateDetail(item) {
      this.$store.commit('inspectionSet', {page: this.form.page,count: this.form.count, deviceId: this.form.deviceId,type:this.form.type});
      this.$router.push({path:'inspectionDetail',query: {id:item.id}})
    },
    handleSelectionChange(val) {
      this.exportData = val
      console.log(this.exportData);
    },
    // 导出
    handleExport(row) {
      console.log(this.exportData);
      console.log(this.exportData.length < 1 && row)
      if (this.exportData.length < 1 && !row) {
        this.$message.warning(this.$t('pleaseSelectDataExport'))
        return
      }
      // 第一步：处理导出数据（核心：计算 score = 三个分数之和）
      let exportList = []; // 存储处理后的导出数据
      if(row) {
        // 单个导出（点击某行的“导出”按钮）
        exportList = [{...row}]; // 深拷贝当前行数据，避免修改原数据
      } else {
        // 批量导出（选中多条数据）
        exportList = [...this.exportData]; // 深拷贝选中数据
      }

      // 遍历数据，计算 score（三个分数之和）
      exportList = exportList.map(item => {
        // 1. 先处理“空值”：若某分数为 undefined/null，默认按 0 计算
        const lubrication = Number(item.lubricationScore) || 0;
        const clean = Number(item.cleanScore) || 0;
        const adjust = Number(item.adjustScore) || 0;

        const totalScore = lubrication + clean + adjust;

        // 2. 转换 printType（补全 case '2' 的逻辑，与表格显示一致）
        let printTypeText = '';
        switch (item.printType) {
          case '0':
            printTypeText = this.$t('pre_press'); // 印前
            break;
          case '1':
            printTypeText = this.$t('printing'); // 印刷
            break;
          case '2':
            printTypeText = this.$t('Post_Press'); // 印后（表格中已有该逻辑，此处同步）
            break;
          default:
            printTypeText = ''; // 默认空（避免异常值）
        }

        // 3. 转换 daType（与表格中维护类型显示逻辑完全一致）
        let daTypeText = '';
        switch (item.daType) {
          case '1':
            daTypeText = this.$t('day_maintainance'); // 日常保养
            break;
          case '2':
            daTypeText = this.$t('weeks_maintainance'); // 周保养
            break;
          case '3':
            daTypeText = this.$t('months_maintainance'); // 月保养
            break;
          case '30':
            daTypeText = this.$t('half_months_maintainance'); // 半月保养
            break;
          case '4':
            daTypeText = this.$t('quarter_maintainance'); // 季度保养
            break;
          case '5':
            daTypeText = this.$t('half_year_maintainance'); // 半年保养
            break;
          case '6':
            daTypeText = this.$t('year_maintainance'); // 年保养（对应 option 中的 annual_maintenance）
            break;
          default:
            daTypeText = ''; // 默认空
        }

        // 4. 合并维护类型文字（printTypeText + daTypeText，与表格显示一致）
        const maintenanceTypeText = printTypeText + daTypeText;

        // 返回处理后的数据（保留原字段，新增/覆盖计算后的字段）
        return {
          ...item,
          score: totalScore, // 覆盖 score 为总分（供 total_score 列使用）
          maintenanceTypeText: maintenanceTypeText // 新增临时字段（供 maintenance_type 列使用）
        };
      });
      require.ensure([], () => {
        const {export_json_to_excel} = require('@/views/ExcelLeadOut/Export2Excel'); // 注意这个Export2Excel路径
        const tHeader = [
          this.$t('device_add_name'),
          this.$t('sheet_number'),
          this.$t('maintenance_type'),
          this.$t('maintenance_time'),
          this.$t('baoyangren'),
          this.$t('inspector'),
          this.$t('inspection_time'),
          this.$t('total_score'),
          this.$t('LubricationScore'),
          this.$t('InspectionCleaningScore'),
          this.$t('AdjustmentScore'),

        ]; // 表格标题
        const filterVal = [
          'deviceName',
          'code',
          'maintenanceTypeText',
          'maintainDate',
          'person',
          'checkPerson',
          'date',
          'score',
          'lubricationScore',
          'cleanScore',
          'adjustScore',

        ]; // 标题属性key值
        const data = this.formatJson(filterVal, exportList);
        export_json_to_excel(tHeader, data, this.$t('spotCheckRecordExportDataTable'),this.$t('inspection_record')); // 倒数第二个是表名字，最后一个是sheet表名字
        // })

      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    // 分页器
    handleSizeChange(val) {
      this.form.count = val;
      this.getTemplateList();
    },
    // 分页器
    handleCurrentChange(val) {
      this.form.page = val;
      this.getTemplateList();
    },
  },
};
</script>

<style lang="scss" scoped>
#upload {
  position: relative;
  margin: 15px 0;
  width: 300px;
  height: 150px;
  background: rgba(134, 132, 132, 0.5);
  border-radius: 5px;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.el-icon-upload {
  display: block;
  width: 50px;
  height: 50px;
  font-size: 50px;
  margin: 10px 50px;
}
.upload-text {
  width:200px;
  text-align: center;
}
.control-box {
  .el-form-item {
    margin-bottom: 22px;
    //margin-right: 15px;
  }
}
</style>
